import { io } from "socket.io-client";
import { serverUrl } from "../../Config/Config";

export const notificationSocket = io(`${serverUrl}/notifications`, {
  autoConnect: false,
  transports: ["websocket"],
  withCredentials: true,
});
